import { localStorageService } from '@hooks/useWebStorage.hook'
import {
  CURRENT_TERMS_VERSION_ID,
  TERMS_ACK_STORAGE_KEY,
  type TermsAck,
} from './termsUpdateAck.constants'

export const readTermsAck = (): TermsAck | null => {
  return localStorageService.getItem<TermsAck>(TERMS_ACK_STORAGE_KEY)
}

export const writeTermsAck = (ack: TermsAck): void => {
  localStorageService.setItem(TERMS_ACK_STORAGE_KEY, ack)
}

export const needsTermsUpdateAck = (
  ack: TermsAck | null = readTermsAck(),
  currentVersionId: string = CURRENT_TERMS_VERSION_ID,
): boolean => {
  return needsTermsUpdateAckForVersion(ack?.versionId, currentVersionId)
}

/** Profile-backed ack from GET /me `meta.termsAckVersionId`. */
export const needsTermsUpdateAckForVersion = (
  acknowledgedVersionId: string | null | undefined,
  currentVersionId: string = CURRENT_TERMS_VERSION_ID,
): boolean => {
  return acknowledgedVersionId !== currentVersionId
}

export const acknowledgeCurrentTerms = (
  currentVersionId: string = CURRENT_TERMS_VERSION_ID,
): TermsAck => {
  const ack: TermsAck = {
    versionId: currentVersionId,
    acknowledgedAt: new Date().toISOString(),
    surface: 'pwa',
  }
  writeTermsAck(ack)
  return ack
}
